import React, { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import SearchIcon from './search.svg';

import style from './Search.scss';

const cn = bemCssModules(style, 'Search');
const ti = getTestId('Search');

export type TSearch = {
  isDetailPage?: boolean;
  onChange(event: React.ChangeEvent<HTMLInputElement>): void;
};

const Search: CustomFC<TSearch> = ({ isDetailPage = false, onChange, className }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (isDetailPage) inputRef.current?.focus();
  }, []);

  return (
    <div className={cn({ isDetailPage }, [className])} data-testid={ti()}>
      <SearchIcon className={cn('search-icon')} />
      <input
        ref={inputRef}
        className={cn('search-input')}
        placeholder={t('wallets.search_placeholder_details')}
        type="search"
        onChange={onChange}
      />
    </div>
  );
};

export default Search;
